import React, { useEffect, useState } from "react";
import {
  BIRTHDAY_RESERVATION,
  CALENDAR_SALE,
  CUSTOM_OFFER,
  EVENT_SALE,
  EXERCISE_SCHEDULE,
  GIFT_CARD_ACTIVE,
  LIMITED_TICKET_COLOR,
  LIMITED_TICKET_GROUP,
  LIMITED_TICKET_SHAPE,
  MAIN_APP,
  NEWS_PAGE,
  PASSES_SALE,
  THREE_STEP,
} from "../../../app/routes";
import { ComponentList } from "../../../app/models/ComponentList";
import { useTranslation } from "react-i18next";
import NaviLink from "./NaviLink";

interface IProps {
  item: ComponentList;
  onClick?: () => void;
  isCustomOffer?: boolean;
}

const SubpageNavBarButton: React.FC<IProps> = ({ item, onClick = () => {}, isCustomOffer = false }: IProps) => {
  const { t } = useTranslation();
  const [link, setLink] = useState("");

  const linkMap: { [key: string]: string } = {
    EventSaleActive: EVENT_SALE,
    NewsActive: NEWS_PAGE,
    GiftCardActive: GIFT_CARD_ACTIVE,
    StepByStepSaleActive: THREE_STEP,
    StepByStepSaleActiveV2: CALENDAR_SALE,
    BirthDaysActive: BIRTHDAY_RESERVATION,
    PassSale: PASSES_SALE,
    Calendar: EXERCISE_SCHEDULE,
    Shapes: LIMITED_TICKET_SHAPE,
    Groups: LIMITED_TICKET_GROUP,
    Colors: LIMITED_TICKET_COLOR,
  };

  useEffect(() => {
    if (isCustomOffer) {
      setLink(`${CUSTOM_OFFER}?offerId=${item.id}`);
    } else {
      setLink(linkMap[item.id] || MAIN_APP);
    }
    //eslint-disable-next-line
  }, [item]);

  return (
    <React.Fragment>{item.active && <NaviLink onClick={onClick} title={t(item.name)} link={link} />}</React.Fragment>
  );
};

export default SubpageNavBarButton;
